import { apiRequest, API_BASE_URL } from './api.config';
import { ApiResponse } from '@utilities/types';

export interface CollarFeltCategory {
    id: string;
    label: string;
    options: Array<{ id: string; name: string; image: string }>;
}

export async function getCollarFeltCatalog(): Promise<CollarFeltCategory[]> {
    const res = await apiRequest<ApiResponse<{ categories: CollarFeltCategory[] }>>('/collar-felts/catalog', { cache: 'no-store' });
    const staticBase = (API_BASE_URL || '').replace(/\/api\/v1$/, '');
    return (res.data.categories || []).map((category) => ({
        ...category,
        options: category.options.map((option) => ({ ...option, image: `${staticBase}${option.image}` })),
    }));
}
